var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-510.000000, -3062.000000)",
    stroke: "#f2c7ef",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-Merchants",
    transform: "translate(320.000000, 3046.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(24.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "167.310547 4.23657227 171.310547 8 167.310547 11.7634277"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRed);
export default __webpack_public_path__ + "static/media/arrowRightRed.d9f904402cc5de5c3db4c296cea19dba.svg";
export { ForwardRef as ReactComponent };